module.exports = __webpack_public_path__ + "static/media/biotrue.c383936c.png";